import { FINE_FLAGS } from "../../../authRegistry.js";
import { editSecurityPermission } from "./actions.js";
import { groupBy } from "lodash";

const createField = ({ category, flag, uiLabel }) => {
    
    return {
        "label": uiLabel || flag,
        "key": `Security.${category}.${flag}`,
        "type": "bool",
        "actionButton": !(category === "General" && flag === "User"),
        "actionText": "Edit",
        "actionClass": "primary",
        actionDisabled({ pageItem, store }) {
            return store?.state?.user?.Security?.General?.ApplicationAdmin !== true
        },
        action: editSecurityPermission({ category, flag, uiLabel }),
    };
};

// Generate the security map from the authRegistry FINE_FLAGS
// This ensures UserManager UI and the registry stay in sync
const groupedFlags = groupBy(FINE_FLAGS, "category");

export default Object.entries(groupedFlags).map(([category, flags]) => {
    return {
        "label": category.split(/(?=[A-Z])/).join(" "),
        "key": category,
        "local": true,
        "field": true,
        "fields": flags.map(createField)
    }
});
